import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Import the CSS
import '../../scss/components/_checkbox.scss';

export default class Checkbox extends Component {

	static propTypes = {
		name: PropTypes.string.isRequired,
		type: PropTypes.string,
		style: PropTypes.string,
		label: PropTypes.string,
		className: PropTypes.string,
	}

	render () {

		const classes = [ 'checkbox' ];

		// Add additional classes based on the props
		if (this.props.type) {
			classes.push(`checkbox-${this.props.type}`);
		}
		if (this.props.style) {
			classes.push(`checkbox-${this.props.style}`);
		}
		if (this.props.className) {
			classes.push(this.props.className);
		}

		const inputProps = _.omit(this.props, [ 'className', 'type', 'style', 'label' ]);

		return (
			<div className={ classes.join(' ') }>
				<input type="checkbox" id={ this.props.name } { ...inputProps } />
				<label className="checkbox-mark" htmlFor={ this.props.name } />
				<If condition={ this.props.label }>
					<label className="checkbox-label" htmlFor={this.props.name}>{ this.props.label }</label>
				</If>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/assets/js/components/Checkbox.js